import React from "react";
import Tr from "./Tr";

/**
 * Table Component
 * Displays background price data in a table format
 */
export default function Table({
  data,
  onEdit,
  onDelete,
  rankColorMap,
  isAllowedToEditOrDelete,
  cryptoPrice
}) {
  return (
    <div className="form-container">
      <table className="table">
        <thead>
          <tr>
            <th className="col-numeric-date">Background</th>
            <th className="col-numeric-date">Rank</th>
            <th className="col-numeric-date">Price in AVAX</th>
            <th className="col-numeric-date">Price in USD</th>
            <th className="col-options">Options</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={4}>No data found....</td>
            </tr>
          ) : (
            data.map((d, index) => (
              <Tr
                key={d.background_price_id || index}
                color={rankColorMap[d.rank]}
                id={d.background_price_id}
                campaign_id={d.campaign_id}
                rank={d.rank}
                price={d.price}
                cryptoPrice={cryptoPrice}
                onEdit={onEdit}
                onDelete={onDelete}
                isAllowedToEditOrDelete={isAllowedToEditOrDelete}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
